export default __webpack_public_path__ + "static/media/Banner.9434429a.png";